import { useState, useEffect } from "react";
import axios from "axios";

const useFetchVersions = (role) => {
  const [wpVersion, setWpVersion] = useState({});
  const [phpVersion, setPhpVersion] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchVersions = async () => {
        setIsLoading(true);
        try {
        const res = await axios.get(process.env.REACT_APP_DOMAIN_URL+"/api/versions");
        setWpVersion(res.data.wp);
        setPhpVersion(res.data.php);
        } catch (err) {
        console.error(err);
        setWpVersion("Erreur");
        setPhpVersion("Erreur");
        } finally {
        setIsLoading(false);
        }

  };

    useEffect(() => {
    fetchVersions();
    }, []);

    return { wpVersion, phpVersion, isLoading, error, refreshData: fetchVersions };
}
export default useFetchVersions;
